export default "__VITE_ASSET__697551f2__"